define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
      url: function(){
            const baseUrl = '/delegate/civics-api/api/portal/auth';
            return this.useFallback ? baseUrl + '?mfa_fallback=true' : baseUrl;
      }

    //url: '/delegate/civics-api/api/portal/auth?username=' + this.get('userName') + '&password=' + this.get('password'),
    //03-09-17 - Changed to a POST

  });
});
